import React from "react";
import { Icon } from "./Icon";
import { Link } from "react-router-dom";
import { PageMeta } from "./PageMeta";

const TermsOfService: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0a0a0a",
        padding: "40px 20px",
        width: "100%",
      }}
    >
      <PageMeta
        title="Terms of Service — HAL 8580"
        description="The terms that govern use of HAL 8580, the AI-powered Twitch chat bot — accounts, acceptable use, subscriptions, and liability."
        path="/terms"
        breadcrumbs={[{ name: "Terms of Service" }]}
      />
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: "#1a1f2e",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
        }}
      >
        <Link
          to="/dashboard"
          style={{
            color: "#9146FF",
            textDecoration: "none",
            fontSize: "14px",
            display: "inline-block",
            marginBottom: "20px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#a855f7";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#9146FF";
          }}
        >
          <Icon
            name="arrow-left"
            size={14}
            style={{ verticalAlign: "-2px", marginRight: "6px" }}
          />
          Back to Dashboard
        </Link>

        <h1 style={{ color: "#ffffff", marginBottom: "10px" }}>
          Terms of Service
        </h1>
        <p style={{ color: "#cbd5e0", marginBottom: "30px", fontSize: "14px" }}>
          Last updated: January 2025
        </p>

        <div style={{ color: "#cbd5e0", lineHeight: "1.8" }}>
          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: "15px" }}>
              By accessing and using HAL 8580 (&quot;the Service&quot;), you
              agree to be bound by these Terms of Service (&quot;Terms&quot;).
              If you do not agree to these Terms, please do not use the Service.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              2. Description of Service
            </h2>
            <p style={{ marginBottom: "15px" }}>
              HAL 8580 is an AI-powered Twitch chat bot service that provides
              automated chat interaction, moderation assistance, and engagement
              features for Twitch streamers. The Service includes:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                AI-powered chat responses
              </li>
              <li style={{ marginBottom: "10px" }}>
                Custom personality and context configuration
              </li>
              <li style={{ marginBottom: "10px" }}>Stream event responses</li>
              <li style={{ marginBottom: "10px" }}>
                User memory and knowledge base features
              </li>
              <li style={{ marginBottom: "10px" }}>
                Dashboard for bot management
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              3. User Accounts
            </h2>
            <p style={{ marginBottom: "15px" }}>
              To use the Service, you must:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Have a valid Twitch account
              </li>
              <li style={{ marginBottom: "10px" }}>
                Provide accurate and complete information
              </li>
              <li style={{ marginBottom: "10px" }}>
                Maintain the security of your account credentials
              </li>
              <li style={{ marginBottom: "10px" }}>
                Notify us immediately of any unauthorized access
              </li>
              <li style={{ marginBottom: "10px" }}>
                Be responsible for all activities under your account
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              4. Acceptable Use
            </h2>
            <p style={{ marginBottom: "15px" }}>
              You agree to use the Service in compliance with all applicable
              laws and regulations. You may not:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Use the Service to violate Twitch&apos;s Terms of Service or
                Community Guidelines
              </li>
              <li style={{ marginBottom: "10px" }}>
                Generate or distribute harmful, offensive, or illegal content
              </li>
              <li style={{ marginBottom: "10px" }}>
                Attempt to bypass rate limits or abuse the Service
              </li>
              <li style={{ marginBottom: "10px" }}>
                Impersonate others or misrepresent your affiliation
              </li>
              <li style={{ marginBottom: "10px" }}>
                Use the Service for spam, harassment, or malicious purposes
              </li>
              <li style={{ marginBottom: "10px" }}>
                Reverse engineer, decompile, or attempt to extract source code
              </li>
              <li style={{ marginBottom: "10px" }}>
                Resell or redistribute the Service without authorization
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              5. Bot Behavior and Content
            </h2>
            <p style={{ marginBottom: "15px" }}>
              While we strive to ensure appropriate bot responses:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                You are responsible for monitoring and moderating your
                bot&apos;s behavior
              </li>
              <li style={{ marginBottom: "10px" }}>
                AI-generated responses may occasionally be inaccurate or
                inappropriate
              </li>
              <li style={{ marginBottom: "10px" }}>
                You should configure appropriate keywords and context for your
                channel
              </li>
              <li style={{ marginBottom: "10px" }}>
                We reserve the right to limit or suspend bots that violate
                guidelines
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              6. Service Availability
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We strive to maintain high availability but do not guarantee
              uninterrupted service. The Service may be temporarily unavailable
              due to:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>Scheduled maintenance</li>
              <li style={{ marginBottom: "10px" }}>
                Technical issues or outages
              </li>
              <li style={{ marginBottom: "10px" }}>
                Third-party service disruptions
              </li>
              <li style={{ marginBottom: "10px" }}>Force majeure events</li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              7. Pricing and Payments
            </h2>
            <p style={{ marginBottom: "15px" }}>
              The Service currently offers:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>
                Free tier with basic features and rate limits
              </li>
              <li style={{ marginBottom: "10px" }}>
                Premium features may be introduced with separate pricing
              </li>
              <li style={{ marginBottom: "10px" }}>
                Any paid features will be clearly marked and require explicit
                consent
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              8. Intellectual Property
            </h2>
            <p style={{ marginBottom: "15px" }}>
              The Service and its original content, features, and functionality
              are owned by Squidcode LLC and are protected by international
              copyright, trademark, and other intellectual property laws.
            </p>
            <p style={{ marginBottom: "15px" }}>
              You retain ownership of any custom content you provide (custom
              context, keywords, etc.) but grant us a license to use this
              content to provide the Service.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              9. Limitation of Liability
            </h2>
            <p style={{ marginBottom: "15px" }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, SQUIDCODE LLC SHALL NOT BE
              LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
              PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS,
              DATA, USE, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE.
            </p>
            <p style={{ marginBottom: "15px" }}>
              Our total liability shall not exceed the amount you have paid us
              in the twelve (12) months preceding the claim.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              10. Indemnification
            </h2>
            <p style={{ marginBottom: "15px" }}>
              You agree to indemnify and hold harmless Squidcode LLC, its
              officers, directors, employees, and agents from any claims,
              damages, losses, or expenses arising from:
            </p>
            <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
              <li style={{ marginBottom: "10px" }}>Your use of the Service</li>
              <li style={{ marginBottom: "10px" }}>
                Your violation of these Terms
              </li>
              <li style={{ marginBottom: "10px" }}>
                Your violation of any third-party rights
              </li>
              <li style={{ marginBottom: "10px" }}>
                Content generated by your bot instance
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              11. Termination
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We reserve the right to terminate or suspend your account at our
              discretion, without notice, for conduct that we believe violates
              these Terms or is harmful to other users, us, or third parties.
            </p>
            <p style={{ marginBottom: "15px" }}>
              You may terminate your account at any time by contacting support
              or through account settings.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              12. Changes to Terms
            </h2>
            <p style={{ marginBottom: "15px" }}>
              We reserve the right to modify these Terms at any time. We will
              notify users of any material changes via email or through the
              Service. Your continued use of the Service after changes
              constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              13. Governing Law
            </h2>
            <p style={{ marginBottom: "15px" }}>
              These Terms shall be governed by and construed in accordance with
              the laws of California, United States, without regard to its
              conflict of law provisions.
            </p>
          </section>

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                color: "#ffffff",
                marginBottom: "15px",
                fontSize: "20px",
              }}
            >
              14. Contact Information
            </h2>
            <p style={{ marginBottom: "15px" }}>
              For questions about these Terms, please visit our{" "}
              <Link
                to="/support"
                style={{ color: "#9146FF", textDecoration: "none" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#a855f7";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#9146FF";
                }}
              >
                Support page
              </Link>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
